export const DATA_ANALYSIS_PERSMISSION_KEY = 'dataAnalysisPermission';
